// eslint-disable-next-line no-unused-vars
module.exports = (cookieName, domain = '') => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
